var EngineAttributeTypes;
(function (EngineAttributeTypes) {
    EngineAttributeTypes["FUEL_TYPE"] = "fuelType";
    EngineAttributeTypes["MAXIMUM_SPEED"] = "maximumspeed";
    EngineAttributeTypes["TRANSMISSION"] = "transmission";
    EngineAttributeTypes["SHORT_NAME"] = "shortname";
    EngineAttributeTypes["SHORT_DESCRIPTION"] = "shortdescription";
    EngineAttributeTypes["LONG_DESCRIPTION"] = "longdescription";
    EngineAttributeTypes["FULL_SPECS_URL"] = "fullSpecsUrl";
    EngineAttributeTypes["TRANSMISSION_TYPE"] = "transmissionType";
    EngineAttributeTypes["TRANSMISSION_LABEL"] = "transmissionLabel";
    EngineAttributeTypes["MOTOR"] = "motor";
    EngineAttributeTypes["CAPACITY"] = "capacity";
    EngineAttributeTypes["PROPULSION"] = "propulsion";
    EngineAttributeTypes["ENGINE_POWER"] = "enginepower";
    EngineAttributeTypes["FUEL_ECONOMY"] = "fueleconomy_nedcequivalent";
    EngineAttributeTypes["ACCELERATION"] = "acceleration";
    EngineAttributeTypes["OEM_CODE"] = "oemcode";
    EngineAttributeTypes["FUEL_ECONOMY_CO2"] = "fueleconomy_nedcequivalent_co2";
    EngineAttributeTypes["FUEL_LABEL"] = "fuelLabel";
})(EngineAttributeTypes || (EngineAttributeTypes = {}));
export default EngineAttributeTypes;
//# sourceMappingURL=EngineAttributeTypes.js.map